import type { Price } from './price'

export const PRICE_LINE_TYPE_TOTAL = 'total'
export const PRICE_LINE_TYPE_PRODUCT = 'product'
export const PRICE_LINE_TYPE_DISCOUNT = 'discount'
export const PRICE_LINE_TYPE_COMBI_DEAL_DISCOUNT = 'combiDealDiscount'
export const PRICE_LINE_TYPE_FEE = 'fee'

export type PriceLineType = PRICE_LINE_TYPE_TOTAL | PRICE_LINE_TYPE_PRODUCT | PRICE_LINE_TYPE_DISCOUNT | PRICE_LINE_TYPE_FEE

export type PriceLine = {
  type: string,
  amountWithoutVat: Price,
  vatAmount: Price,
  amountWithVat: Price,
  vatDescription: string,
  title: string
}

const buildPriceLine = function (
  type: string,
  amountWithoutVat: Price,
  vatAmount: Price,
  amountWithVat: Price,
  title: string = '',
  vatDescription: string = ''
): PriceLine {
  return {
    type: type,
    amountWithoutVat: amountWithoutVat,
    vatAmount: vatAmount,
    amountWithVat: amountWithVat,
    vatDescription: vatDescription,
    title: title
  }
}

export {
  buildPriceLine
}



// WEBPACK FOOTER //
// ./src/types/price-line.js